
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"36","viewBox":"0 0 46 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.033 34.913c5.917 0 10.714-4.798 10.714-10.715 0-5.918-4.797-10.715-10.714-10.715-5.918 0-10.715 4.797-10.715 10.715 0 5.917 4.797 10.715 10.715 10.715z","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.833 19.713a10.878 10.878 0 01-1.634-5.703c0-5.925 4.79-10.715 10.715-10.715s10.742 4.79 10.742 10.715","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.352 11.49s4.29-7.253 11.655-9.496c0 0 1.745 6.977 0 11.462","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.508 16.502s7.78-5.703 19.49-1.661c0 0-3.515 8.998-16.223 9.358","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.846 27.466l-1.19.636.249-1.329-.97-.94 1.33-.195.58-1.19.61 1.19 1.301.194-.941.941.221 1.33-1.19-.637z","fill":"#fff","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    